// @flow
import type { State } from 'store/State';

type StatusTracker = {
  // @TODO: add typing
};

export const getStatusTrackerData = (state: State): StatusTracker =>
  state.statusTracker;



// WEBPACK FOOTER //
// ./src/store/reducers/statusTracker/selectors.js